var _circle, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FA9418"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14307,
    y: 5.48206,
    width: 13.7143,
    height: 13.7143,
    fill: "#FA9418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 12.3392C18.8574 13.2859 18.0898 14.0534 17.1431 14.0534H6.85735C5.91058 14.0534 5.14307 13.2859 5.14307 12.3392C5.14307 11.3924 5.91058 10.6249 6.85735 10.6249H17.1431C18.0898 10.6249 18.8574 11.3924 18.8574 12.3392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19.1963C11.0533 19.1963 10.2858 18.4288 10.2858 17.4821L10.2858 7.19634C10.2858 6.24957 11.0533 5.48206 12.0001 5.48206C12.9468 5.48206 13.7144 6.24957 13.7144 7.19634L13.7144 17.4821C13.7144 18.4288 12.9468 19.1963 12.0001 19.1963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.bdc09eb4c15310bcb093e5d1604aab42.svg";
export { ForwardRef as ReactComponent };